// extracted by mini-css-extract-plugin
export default {"table":"ViewCowries_table__CpvTz","search":"ViewCowries_search__AK83Z","icons":"ViewCowries_icons__xgytM"};